import { useEffect } from "react";

import { useAppDispatch } from "app/redux-store-interactions";
import { useAppSelector } from "app/redux-store-interactions";
import { toolbarsActions, useDispatchToolbars } from "contexts/toolbars";
import { renderActions, selectIsSubtreesPanelOpen } from "features/render";
import { SubtreesPopover } from "features/render/subtreesPopover";

import { Toolbar } from "../Toolbar";
import { useViewToolbarButtons } from "./useViewToolbarButtons";

export function ViewToolbar({ id = "view-toolbar" }: { id?: string }) {
    const dispatch = useAppDispatch();
    const toolbarDispatch = useDispatchToolbars();
    const isSubtreesPanelOpen = useAppSelector(selectIsSubtreesPanelOpen);
    const { buttons, subtreesBtnRef } = useViewToolbarButtons();

    useEffect(() => {
        toolbarDispatch(toolbarsActions.addToolbar({ id, buttons }));

        return () => {
            toolbarDispatch(toolbarsActions.removeToolbar(id));
        };
    }, [toolbarDispatch, id, buttons]);

    return (
        <>
            <Toolbar id={id} />
            <SubtreesPopover
                open={isSubtreesPanelOpen}
                anchorEl={subtreesBtnRef.current}
                onClose={() => dispatch(renderActions.setSubtreesPanelOpen(false))}
            />
        </>
    );
}
